
export enum ApiContractTypeCategoryCd {
	HEADER = 'Header',
	PATH = 'Path',
	QUERY = 'Query',
	REQUEST = 'Request',
	RESPONSE = 'Response'}

